import {
    getCountries,
    isPossiblePhoneNumber,
    isValidPhoneNumber,
    parsePhoneNumber,
} from 'libphonenumber-js'
import type {CountryCode} from 'libphonenumber-js'

const supportedCountryCodes = new Set<string>(getCountries());

export const getBrowserCountryCode = (): CountryCode => {
    if (typeof navigator === "undefined") return "US";

    const locales = navigator.languages?.length
        ? navigator.languages
        : [navigator.language];

    for (const locale of locales) {
        try {
            const region = new Intl.Locale(locale).maximize().region?.toUpperCase();
            if (region && supportedCountryCodes.has(region)) {
                return region as CountryCode;
            }
        } catch {
            // Ignore malformed browser locale values and try the next one.
        }
    }

    return "US";
};

export const normalizeImportedPhoneNumber = (
    raw: string,
    defaultCountry: CountryCode = getBrowserCountryCode(),
): string | null => {
    const trimmed = raw.trim();
    if (!trimmed) return null;

    try {
        const internationalValue = trimmed.startsWith("00")
            ? `+${trimmed.slice(2)}`
            : trimmed;
        const hasInternationalPrefix = internationalValue.startsWith("+");

        if (!hasInternationalPrefix && /[^\d\s().\-/]/.test(internationalValue)) {
            return null;
        }
        if (!isValidPhoneNumber(internationalValue, defaultCountry)) return null;

        return parsePhoneNumber(internationalValue, defaultCountry)
            .format("E.164")
            .replace(/\D/g, "");
    } catch {
        return null;
    }
};


export const getFormatedPhoneNumber = (phoneNumber: number | string | null | undefined, noPrefix?:boolean ) => {
    if (!phoneNumber) return 'Unknown';
    if(isPossiblePhoneNumber(`+${phoneNumber.toString()}`)) {
        if(noPrefix) {
            return parsePhoneNumber(`+${phoneNumber.toString()}`).format('NATIONAL', {v2: true});
        } else {
            return parsePhoneNumber(`+${phoneNumber.toString()}`).format('INTERNATIONAL', {v2: true});
        }
    } else {
        return phoneNumber.toString();
    }

}
export const getFlag = (phoneNumber: number | undefined ) => {
    if (phoneNumber) {
        if(isPossiblePhoneNumber(`+${phoneNumber.toString()}`)) {
            return parsePhoneNumber(`+${phoneNumber.toString()}`)?.country?.toLowerCase();
        } else {
            return '';
        }

    }
}

export const getCountryCode = (phoneNumber: number ) => {
    if(isPossiblePhoneNumber(`+${phoneNumber.toString()}`)) {
        return parsePhoneNumber(`+${phoneNumber.toString()}`)?.country;
    } else {
        return '' ;
    }
}


export const regionNames = new Intl.DisplayNames(
    ['en'], { type: 'region' }
  );
